/*eslint-disable*/
import React from "react";
import { send } from "emailjs-com";
import { Helmet } from "react-helmet";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";
import { SiWhatsapp } from "react-icons/si";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import BanglesHeader from "./BanglesHeader.js"
import HeaderLink from "./BanglesHeaderLink.js"

import contactUsStyle from "assets/jss/material-kit-pro-react/views/contactUsStyle.js";

const CustomSkinMap = () => {
  const mapRef = React.useRef(null);
  React.useEffect(() => {
    let google = window.google;
    let map = mapRef.current;
    let lat = "19.1965408";  //19.1965408,72.8275135
    let lng = "72.8275135";
    const myLatlng = new google.maps.LatLng(lat, lng);
    const mapOptions = {
      zoom: 14,
      center: myLatlng,
      scrollwheel: false,
      zoomControl: true,
      styles: [
        {
          featureType: "water",
          stylers: [{ saturation: 43 }, { lightness: -11 }, { hue: "#0088ff" }],
        },
        {
          featureType: "road",
          elementType: "geometry.fill",
          stylers: [
            { hue: "#ff0000" },
            { saturation: -100 },
            { lightness: 99 },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{ color: "#808080" }, { lightness: 54 }],
        },
        {
          featureType: "landscape.man_made",
          elementType: "geometry.fill",
          stylers: [{ color: "#ece2d9" }],
        },
        {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [{ color: "#ccdca1" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#767676" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#ffffff" }],
        },
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        {
          featureType: "landscape.natural",
          elementType: "geometry.fill",
          stylers: [{ visibility: "on" }, { color: "#b8cb93" }],
        },
        { featureType: "poi.park", stylers: [{ visibility: "on" }] },
        {
          featureType: "poi.sports_complex",
          stylers: [{ visibility: "on" }],
        },
        { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
        {
          featureType: "poi.business",
          stylers: [{ visibility: "simplified" }],
        },
      ],
    };

    map = new google.maps.Map(map, mapOptions);

    const marker = new google.maps.Marker({
      position: myLatlng,
      map: map,
      animation: google.maps.Animation.DROP,
      title: "Bangles.Org",
    });

    const contentString =
      '<div class="info-window-content"><h2>Bangles.Org</h2>' +
      "<p>We are one of the top manufacturers and retailers in Maharastra & Karnataka.</p></div>";

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  });
  return (
    <>
      <div
        style={{ height: `100%`, borderRadius: "6px", overflow: "hidden" }}
        ref={mapRef}
      ></div>
    </>
  );
};

const useStyles = makeStyles(contactUsStyle);

export default function BanglesContact() {
  const [toSend, setToSend] = React.useState({
    from_name: "",
    to_name: "",
    message: "",
    reply_to: "",
  });
  // React.useEffect(() => {
  //   window.scrollTo(0, 0);
  //   document.body.scrollTop = 0;
  // });
  const classes = useStyles();

  const handleChange = (name) => (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // console.log(toSend);
    send('service_0bkny47','template_ebdhpsl',toSend,'user_UiIMt4wWoEoLtx2Q454wd')
    .then((res) => console.log(res))
    .catch((err) => console.log("Failed", err));
  };


  return (
    <div>
      <BanglesHeader
        brand="Home"
        links={<HeaderLink dropdownHoverColor="info" />}
        fixed
        color="info"
      />
      <Helmet>
      <meta charset="utf-8" />
        {/* <title>Contact</title> */}
        <meta name="description" content="Don't hesitate to reach out to us to know about your favorite Bangles Manufacture ..... call:+912249786664" />
        <meta name="keywords" content="Shop no.20, Asmita Jyoti CHS D/10/11 bldg, Charkop Naka, Marve Road, Malad West Mumbai-400095 - Maharashtra" />
      </Helmet>
      <div className={classes.bigMap}>
        <CustomSkinMap />
      </div>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.contactContent}>
          <div className={classes.container}>
            <h2 className={classes.title}>Contact us</h2>
            <GridContainer>
              <GridItem md={6} sm={6}>
                <p>
                  Feel free to ask us, If you have any Queries related to our Product.
                  <br />
                  <br />
                </p>
                <form>
                  <CustomInput
                    labelText="Your Name"
                    id="float"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      name:"from_name",
                      value: toSend.from_name,
                      onChange: handleChange(),
                    }}
                  />
                  <CustomInput
                    labelText="Email address"
                    id="float"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      name: "reply_to",
                      value: toSend.reply_to,
                      onChange: handleChange(),
                    }}
                  />
                  <CustomInput
                    labelText="Phone"
                    id="float"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      name: "to_name",
                      value: toSend.to_name,
                      onChange: handleChange(),
                    }}
                  />
                  <CustomInput
                    labelText="Your message"
                    id="float"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      multiline: true,
                      rows: 6,
                      name: "message",
                      value: toSend.message,
                      onChange: handleChange(),
                    }}
                  />
                  <div className={classes.textCenter}>
                    <Button color="primary" round onClick={onSubmit}>
                      Contact us
                    </Button>
                  </div>
                </form>
              </GridItem>
              <GridItem md={6} sm={6} className={classes.mlAuto}>
                <InfoArea
                  className={classes.info}
                  title="Office Address"
                  description={
                    <p>
                      Shop no.20, Asmita Jyoti CHS D/10/11 bldg, <br /> Charkop Naka, Marve Road,{" "}
                      <br /> Malad West Mumbai-400095 - Maharashtra
                    </p>
                  }
                  icon={PinDrop}
                  iconColor="primary"
                />
                <InfoArea
                  className={classes.info}
                  title="Call us at"
                  description={
                    <p>
                     +912249786664 <br /> <span><SiWhatsapp color="green"/> +919967457786</span> <br /> Monday – Saturday, <br />
                      09:00 AM to 06:00 PM <br /> Sunday - 09:00 AM to 02:00 PM
                    </p>
                  }
                  icon={Phone}
                  iconColor="primary"
                />
                <a 
                href={`https://api.whatsapp.com/send?phone=919967457786&text=https://bangles.org.in/%20Hello%20I%20am%20Interested%20in%20your%20Product&app_absent=0`}
                >
                <InfoArea
                  className={classes.info}
                  title="Click on the Whatsapp icon to get connected with us"
                  // description={
                  //   <p>
                  //     Creative Tim Ltd. <br /> VAT · EN2341241 <br /> IBAN ·
                  //     EN8732ENGB2300099123 <br /> Bank · Great Britain Bank
                  //   </p>
                  // }
                  icon={SiWhatsapp}
                  iconColor="success"
                />
                </a>
                {/* <a href="#"><SiWhatsapp size={35} /></a> */}
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <br />
      {/* <BanglesFooter /> */}
    </div>
  );
}
